export default __webpack_public_path__ + "static/media/00.db1fb3b5.jpg";